import { render } from "./SecurityProfileTable.vue?vue&type=template&id=c1be35fc&scoped=true&ts=true"
import script from "./SecurityProfileTable.vue?vue&type=script&lang=ts"
export * from "./SecurityProfileTable.vue?vue&type=script&lang=ts"

import "./SecurityProfileTable.vue?vue&type=style&index=0&id=c1be35fc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1be35fc"]])

export default __exports__